import { gql } from '@apollo/client'

export const UPDATE_TRAINING = gql`
  mutation UpdateTraining($input: UpdateTrainingInput!) {
    updateTraining(input: $input) {
      training {
        title
        description
        id
        timeRequired
        groups {
          id
          name
        }
        deviceType
        trainingImage {
          id
          url
          bucketFileName
        }
      }
    }
  }
`
